import React from 'react';

import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { TSelectFilterOption } from '@/shared/components/ui/option-select/option-select.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

type TIdeOption = {
  label: string;
  value: string;
  additionalInformation?: string | null;
};

// Enriches IDE select options with an info icon + tooltip for consistent rendering
export const mapIdeOptionsWithInfo = (
  options: TIdeOption[],
): TSelectFilterOption[] =>
  options.map(({ label, value, additionalInformation }) => {
    if (!additionalInformation) {
      return { label, value };
    }

    return {
      label,
      value,
      additionalInfo: (
        <Tooltip title={additionalInformation} placement="right">
          <InfoIcon color="textSecondary" size="1rem" />
        </Tooltip>
      ),
    };
  });
